import { api } from "../base";

const algoEndpoints = api.injectEndpoints({
  endpoints: (build) => ({
    /** Fetches strategy instance statuses. Designed for pollingInterval use. */
    getAlgoStatus: build.query<Record<string, unknown>, void>({
      query: () => ({ url: "/api/algo/v1/strategy_instance_status" }),
      providesTags: ["AlgoStatus"],
    }),

    /** Fetches interaction definitions per connection. */
    getAlgoInteractions: build.query<Record<string, unknown>, void>({
      query: () => ({ url: "/api/algo/v1/interaction" }),
      providesTags: ["AlgoInteractions"],
    }),
  }),
});

export const {
  useGetAlgoStatusQuery,
  useGetAlgoInteractionsQuery,
} = algoEndpoints;
